import { render } from "./SenderPartial.html?vue&type=template&id=767de12f"
import script from "./SenderPartial.js?vue&type=script&lang=js"
export * from "./SenderPartial.js?vue&type=script&lang=js"

import "./SenderPartial.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__